/** Service Desk console: E-mail quarantine (CH-030, SD-S1-64 screen). Mail that named a ticket but could not join it. */
export const serviceQuarantine = {
  nav: { quarantine: "E-mail quarantine" },
  title: "E-mail quarantine",
  subtitle: "Mail that named a ticket but could not join it. Nothing here is ever sent back to the sender.",
  noRights: { title: "You can't review quarantined mail", body: "Reviewing needs the ticket manager permission. Ask a workspace owner to give it to you." },
  filter: { label: "Show messages", pending: "Waiting", accepted: "Released", rejected: "Discarded" },
  table: {
    label: "Quarantined messages",
    from: "From",
    subject: "Subject",
    reason: "Why it waits",
    ticket: "Ticket",
    received: "Received",
    expires: "Expires",
    noSubject: "(no subject)",
    noTicket: "None named",
    open: "Open message from {{from}}",
    showing: "Showing {{shown}} of {{total}} messages",
    loadMore: "Load more",
  },
  reason: {
    sender_mismatch: "Sender does not match the ticket",
    no_visibility: "Sender cannot see this ticket",
    unknown_token: "Unknown reply address",
    revoked_token: "Reply address was revoked",
    auth_failed: "Sender could not be verified",
  },
  status: { pending: "Waiting", accepted: "Released", rejected: "Discarded" },
  detail: {
    title: "Quarantined message",
    description: "Review what the sender wrote. Release it to add it to the ticket as a public message, or discard it.",
    to: "Sent to",
    received: "Received {{time}}",
    expires: "Deleted on {{time}} if nobody decides",
    reviewed: "Decided {{time}}",
    ticket: "Ticket named",
    openTicket: "Open {{number}}",
    noTicket: "The message did not name a ticket, so it can only be discarded.",
    body: "Message",
    noBody: "(the message had no text)",
    files: "Files ({{count}})",
    filesHint: "Scanned for viruses when the message is released.",
    checks: "Delivery checks",
    spf: "SPF",
    dkim: "DKIM",
    unknownCheck: "Not reported",
    messageId: "Message ID",
    close: "Close",
  },
  actions: {
    release: "Release to ticket",
    discard: "Discard",
    cancel: "Cancel",
    releaseTitle: "Release to {{ticket}}?",
    releaseBody: "The sender's words and scanned files become a public message on {{ticket}}. The client and the team will see them.",
    releaseConfirm: "Release to ticket",
    released: "Released to {{ticket}}.",
    discardTitle: "Discard this message?",
    discardBody: "It is not added to any ticket and the files are deleted. The sender is not told.",
    discardConfirm: "Discard message",
    discarded: "Message discarded.",
    decided: "Someone already decided this message. The list is refreshed.",
    failed: "We couldn't complete that. Nothing was changed.",
  },
  empty: {
    title: "Quarantine is clear",
    body: "Mail that can't join its ticket waits here for you. Nothing is waiting right now.",
    filteredTitle: "No {{status}} messages",
    filteredBody: "Messages you decide on appear here for 30 days.",
    action: "Show waiting messages",
  },
  error: { title: "We couldn't load the quarantine", body: "Something went wrong on our side. Please try again.", retry: "Try again" },
} as const;
